<template>
    <div>
        <input type="file" style="display: none" ref="input" @change="getImage()">
        <button class="btn blue" @click.prevent="triggerInput()">Ajouter une image</button>
    </div>
</template>

<script>
export default {

  name: 'image-upload',

  data () {
    return {
        image: Object
    }
  },
  methods: {
    triggerInput () {
        this.$refs['input'].click()
    },
    getImage () {
        this.image = new Image(event);
    }
  }
};
</script>

<style lang="css" scoped>
</style>
